import React from 'react';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { AgentFormValues } from '../../interfaces/types';
import { RadioGroup } from '@navi/web-ui/lib/components';
import { TOP_AGENT_OPTIONS } from '../../constants/constants';

type AgentFormRadioButtonProps = {
  control: Control<AgentFormValues>;
  name: keyof AgentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  isEditDisabled: boolean | undefined;
  styles: CSSModuleClasses;
  inputLabel: string;
  showRequiredIcon?: boolean;
  defaultValue?: string;
  onChange?: () => void;
};

const AgentFormRadioButton: React.FC<AgentFormRadioButtonProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled,
    styles,
    inputLabel,
    showRequiredIcon = true,
    defaultValue = '',
    onChange
  } = props;

  const [selectedRadioOption, setSelectedRadioOption] = React.useState<string>(defaultValue);

  const handleRadioChange = (value: string) => {
    if (isEditDisabled) return;
    setSelectedRadioOption(value);
    onChange?.();
  };

  return (
    <>
      <div className={cx(styles.textContainer, 'pb-1')}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          {inputLabel}
        </Typography>
        {showRequiredIcon ? <RequiredIcon /> : null}
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            onChange={(e: React.SyntheticEvent) => {
              const value = (e?.target as HTMLInputElement)?.value;
              onChange(value);
              handleRadioChange(value);
            }}
            value={selectedRadioOption}
            name="agentType"
            options={TOP_AGENT_OPTIONS}
            error={errors && errors[name] && errors[name].message}
            disabled={isEditDisabled}
          />
        )}
      />
    </>
  );
};

export default AgentFormRadioButton;
